import styled from 'styled-components';
import { Styling, Colors } from '../../../../../constants';

export const NotFoundLabel = styled.span`
  color: ${Colors.DARK_RED};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
